import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';
import { CategoryItem } from '../_models/category-item';
import { NavigationItem } from '../_models/navigation-item';
import { CODE_PAGE_TRANG_CHU } from '../_models/predefined-code-list';

@Injectable({
  providedIn: 'root',
})
export class StateService {
  navTree$: BehaviorSubject<
    {
      item: NavigationItem;
      children: {
        item: NavigationItem;
        children?: {
          item: NavigationItem;
        }[];
      }[];
    }[]
  > = new BehaviorSubject<
    {
      item: NavigationItem;
      children: {
        item: NavigationItem;
        children?: {
          item: NavigationItem;
        }[];
      }[];
    }[]
  >([]);
  categories$: BehaviorSubject<CategoryItem[]> = new BehaviorSubject<CategoryItem[]>([]);
  navigationCodeMap$: BehaviorSubject<{ [code: string]: NavigationItem }> = new BehaviorSubject<{ [code: string]: NavigationItem }>({});
  token$: BehaviorSubject<string> = new BehaviorSubject<string>('');
  currentPage$: BehaviorSubject<string> = new BehaviorSubject<string>(CODE_PAGE_TRANG_CHU);
  beforePage$: BehaviorSubject<string> = new BehaviorSubject<string>(CODE_PAGE_TRANG_CHU);
  currentLanguage$: BehaviorSubject<string> = new BehaviorSubject<string>('vi');
  changeSiteLanguage$: BehaviorSubject<string> = new BehaviorSubject<string>('');
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  investFunds$: BehaviorSubject<any | undefined> = new BehaviorSubject<any | undefined>(undefined);
  isServer$: BehaviorSubject<boolean> = new BehaviorSubject<boolean>(false);
  search$: BehaviorSubject<string> = new BehaviorSubject<string>('');
}
